<template>
    <guide-page v-bind:config="pageConfig" :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :shareHaderName="shareHaderName"></guide-page>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuidePage from '../component/GuidePage.vue';

export default {
  name: 'BindWeChat',
  components: {
    guidePage: GuidePage,
  },
  data() {
    return {
      wxaPage: 'pages/me/guide/guide-page/guide-page',
      wxaPageParam: 'key=2',
      shareHaderName: '绑定微信',
      pageConfig: {
        sections: [
          {
            steps: [
              {
                description: [
                  '登录666visa.cn，输入账号密码，登录后使用微信扫描二维码进行账号绑定；',
                ],
                sub: [
                  {
                    images: [
                      {
                        name: '2_01',
                        align: 'left',
                      },
                    ],
                  },
                ],
              },
              {
                description: ['输入账号密码，点击「确定」，绑定成功！'],
                sub: [
                  {
                    images: [{ name: '2_02' }],
                  },
                ],
              },
              {
                description: ['下次如何找到办签助手小程序？'],
                tips:
                  '* 若店员未找到小程序入口，请先在上上签官网绑定微信或升级微信至最新版本再试',
                sub: [
                  {
                    images: [{ name: '2_03' }],
                  },
                ],
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    sensorsdata.track('UserGuide', {
      guide_name: '绑定微信',
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/guide/sub/BindWeChat.vue